/**
 * 通知分類 — 全站單一來源（票 33）。
 *
 * 為什麼要有這個檔案：分類的中文字串原本在**三個地方各寫一次** ——
 * `mock/db/notifications.js`（產資料）、`Notify/NotifyPage.js` 的 `TABS`（分頁篩選）、
 * `Dashboard/index.js`（待辦清單篩選）。
 *
 * 三份就會有一份寫錯：看板寫的是 `category === "到期"`，而種子產的是「到期類型」——
 * **沒有一筆對得上，那一列永遠是空的**，畫面上看起來像「今天沒有到期的事」。
 * 種子裡五筆到期類通知（EOS／EOL／CVE／KEV／合約到期）一筆都進不了看板，
 * 而且不會報錯、不會有人發現。這是 CLAUDE.md 測試面向表裡「值語意」那一條的實例。
 *
 * 分頁 key 與 i18n 的 `notify.tabs.*` 共用同一組 key，所以標題文字仍由 i18n 決定，
 * 這裡只負責「哪些分類存在」與「分頁 key 對到哪個分類值」。
 */

/** 六個分類（值＝資料上的 `category` 欄位內容） */
export const NOTIFY_CATEGORY = {
  UNFILLED: "資料未填",
  DUE: "到期類型",
  STOCK: "低於庫存",
  APPROVAL: "審核流程",
  ALERT: "告警類型",
  VERSION: "版本更新",
};

/** 分頁 key → 分類值（key 對應 i18n `notify.tabs.<key>`） */
export const NOTIFY_CATEGORY_BY_TAB = {
  unfilled: NOTIFY_CATEGORY.UNFILLED,
  due: NOTIFY_CATEGORY.DUE,
  stock: NOTIFY_CATEGORY.STOCK,
  approval: NOTIFY_CATEGORY.APPROVAL,
  alert: NOTIFY_CATEGORY.ALERT,
  version: NOTIFY_CATEGORY.VERSION,
};

export const NOTIFY_CATEGORIES = Object.values(NOTIFY_CATEGORY);

let warnedCategories = new Set();
/**
 * 分類值檢查。後端（`DcMessage`）到位後，`category` 就會是**後端給的字串**，
 * 屆時對不上的值會再次安靜地讓某個分頁變空 —— 所以這裡要吵（ADR-0004）。
 * 回傳原值：寧可畫面上出現一個沒見過的分類，也不要靜靜消失。
 */
export function assertKnownCategory(category) {
  if (!category || NOTIFY_CATEGORIES.includes(category)) return category;
  if (!warnedCategories.has(category)) {
    warnedCategories.add(category);
    console.warn(
      `[notify] 分類「${category}」不在已知清單裡 —— 它不會出現在任何分頁,`,
      `也不會進看板待辦(兩邊都靠分類篩選)。目前認得:${NOTIFY_CATEGORIES.join("／")}。`,
      "請補進 constants/notifyCategories.js。"
    );
  }
  return category;
}
